exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-controls[data-v-64399b1e]{width:100%\n}\n.title-btn[data-v-64399b1e]{display:flex;justify-content:space-between\n}\n#btnClean[data-v-64399b1e]:hover{background-color:#ea4335 !important;transform:scale(1.1)\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-64399b1e","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/forms/ContentSerieForm.vue
// module id = 203
// module chunks = 0